import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Bar = styled.rect(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: all 0.3s ease-in;\n"], ["\n  transition: all 0.3s ease-in;\n"])));
var templateObject_1;
